/**
* DevExpress HTML/JS Reporting (viewer\binding\jsReportParametersPanelBinding.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { createStandaloneParametersPanel } from '../internal/_initializer';
import { JSReportParametersPanel } from './jsReportParametersPanel';
import { JSReportViewerBindingBase } from './jsReportViewerBindingBase';
import { DxDeferred } from '@devexpress/analytics-core/analytics-internal-native';
export class JSReportParametersPanelBinding extends JSReportViewerBindingBase {
    _createModel(element) {
        const model = createStandaloneParametersPanel({
            model: this._options,
            callbacks: this._callbacks,
            element
        });
        return new DxDeferred().resolve(model);
    }
    _createSender(viewModel) {
        return new JSReportParametersPanel(viewModel);
    }
    _showTroubleshootingPageWrapper() {
        return false;
    }
}
